module.exports = __webpack_public_path__ + "media/images/cus_3-a5d20a3942418dd6199d6309ed37e8b4.png";